module.exports = __webpack_public_path__ + "static/media/small-success-4.b9f1e0c6.mp3";